// core
import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';

// services
import {UserRegistrationServiceService} from '../user-registration/service/user-registration-service.service';
import {UtilsService} from '../utils/utils.service';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';

// constants
import {AppConstants} from '../utils/constants';
import {ErrorMessageService} from "../core/alert-message/alert-message.service";

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {

  form: UntypedFormGroup;

  private language: string;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _userRegistrationService: UserRegistrationServiceService,
    private _route: Router,
    private _utilsService: UtilsService,
    private _activatedRoute: ActivatedRoute,
    private errorMessageService: ErrorMessageService,
    private _translateService: TranslateService,
  ) {
    this.form = _formBuilder.group({
      userEmail: [
        {
          value: '',
          disabled: false
        },
        Validators.compose([
          Validators.pattern(this._utilsService.getEmailRegexPattern()),
          Validators.required,
          Validators.maxLength(50)
        ])
      ]
    });
  }

  ngOnInit() {
    this._activatedRoute.queryParams.subscribe((params) => {
      this.language = params['language'];
      if (this.language && this.language != 'null') {
        this._utilsService.setDefaultLanguage(this.language);
      } else {
        this._translateService.onLangChange.subscribe((event: LangChangeEvent) => {
          this.language = event.lang;
          this._utilsService.setDefaultLanguage(this.language);
        });
      }
    });
  }

  /**
   * @description Handler for form submit
   * @param formValues {Object} - form values
   */
  save(formValues) {
    this._userRegistrationService.forgetPassword(formValues.userEmail, this.language).subscribe((response: any) => {
      const re: string = response;
      if (re == "email-not-verified") {
        this._translateService.get("The account for this email has to be first verified. Please check your inbox for the verification email.").subscribe((res: string) => {
          this.errorMessageService.showErrorToastr(res);
        });
      } else {
        this._route.navigate([AppConstants.confirmationPage], {
          queryParams: {
            origin: AppConstants.forgotPassword,
            language: this.language
          }
        });
      }
    });
  }
}
